import { getData } from '../utils/db'

/**
 * The snapshot half of the progress mechanism (server: routes/tasks).
 *
 * Both calls pass `returnError`, so a failure comes back as the response
 * instead of raising the global error banner. A progress display asking about
 * a task that has already expired is an ordinary 404, not something to put in
 * front of the user.
 */
export default class TaskModel {
    /** A tenant's tasks, newest first. */
    public async list(query: { projectId?: string; limit?: number } = {}) {
        const params: string[] = []
        if (query.projectId) params.push(`projectId=${encodeURIComponent(query.projectId)}`)
        if (query.limit) params.push(`limit=${query.limit}`)

        return await getData(`/tasks${params.length ? `?${params.join('&')}` : ''}`, null, true)
    }

    /** One task — for an id the list no longer carries. */
    public async read(taskId: string) {
        return await getData(`/tasks/${taskId}`, null, true)
    }
}
